import { render } from "./management.cattle.io.feature.vue?vue&type=template&id=10298a6a&scoped=true"
import script from "./management.cattle.io.feature.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.feature.vue?vue&type=script&lang=js"

import "./management.cattle.io.feature.vue?vue&type=style&index=0&id=10298a6a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10298a6a"]])

export default __exports__